import React, { FC, memo } from 'react'
import { Container, SliderContainer } from './styles'
import GridCard from '../../common/grid-card'
import { Title, TitleContainer } from '../common/styles'
import { useTranslation } from '../../../hooks/locale'
import { Slide } from 'pure-react-carousel'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { useContinueYourSearchListings } from '../../../hooks/search'
import isEmpty from 'lodash/isEmpty'
import PropertyGridSkeleton from './skeleton'
import { useResponsiveCards } from '../../../hooks/responsive'
import PrevNextControls from '../../common/prev-next-controls'
import { StyledCarouselProvider, StyledSlider } from '../../common/listing-card-section/styles'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { Offer } from '../../../models/common/offers-model'
import { SuitablesModel } from '../../../models/common/suitables-model'

interface Props {
    url: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const ContinueSearchWidget: FC<Props> = ({ url, breadcrumbModel, offerModel, suitablesModel }) => {
    const { listings, isLoading } = useContinueYourSearchListings()
    const { t } = useTranslation()
    const heading = t('pages.home.continueSearch.heading')

    const visibleSlides = useResponsiveCards()
    const dragStep = Math.floor(visibleSlides)

    if (isLoading) {
        return (
            <Container id="continue-search">
                <TitleContainer>
                    <Title>{heading}</Title>
                </TitleContainer>
                <PropertyGridSkeleton />
            </Container>
        )
    }

    const { objects = [] } = listings || {}

    if (isEmpty(objects)) {
        return null
    }

    return (
        <Container id="continue-search">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <SliderContainer>
                <StyledCarouselProvider
                    totalSlides={objects?.length}
                    visibleSlides={visibleSlides}
                    naturalSlideWidth={1}
                    naturalSlideHeight={1}
                    isIntrinsicHeight
                    lockOnWindowScroll
                    dragStep={dragStep}
                    step={dragStep}
                >
                    <PrevNextControls
                        totalObjects={objects.length}
                        visibleSlides={visibleSlides}
                        wideTop="-3.8rem"
                        desktopTop="-3.8rem"
                    />
                    <StyledSlider $transitionTime={0.2}>
                        {objects.map((recommendedObject, index) => (
                            <Slide index={index} key={recommendedObject.id}>
                                <GridCard
                                    index={index}
                                    listingObject={recommendedObject}
                                    requestUrl={url}
                                    pageName={pageTypeEventCategories.HOME}
                                    sectionName={cardEventCategories.sections.CONTINUE_SEARCH}
                                    breadcrumbModel={breadcrumbModel}
                                    offerModel={offerModel}
                                    suitablesModel={suitablesModel}
                                    showFeatures={false}
                                />
                            </Slide>
                        ))}
                    </StyledSlider>
                </StyledCarouselProvider>
            </SliderContainer>
        </Container>
    )
}

export default memo(ContinueSearchWidget)
